var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66334 6.56181C9.90561 6.02034 10.0156 5.59415 10.0156 5.29688C10.0156 3.35525 8.44163 1.78125 6.5 1.78125C4.55837 1.78125 2.98438 3.35525 2.98438 5.29688C2.98438 5.59415 3.09439 6.02034 3.33666 6.56181C3.57301 7.09003 3.90713 7.66696 4.28858 8.24731C5.03632 9.38497 5.92589 10.4758 6.5 11.1465C7.07412 10.4758 7.96368 9.38497 8.71142 8.24731C9.09287 7.66696 9.42699 7.09003 9.66334 6.56181ZM7.05909 11.6946C8.22256 10.3396 10.7969 7.13371 10.7969 5.29688C10.7969 2.92378 8.8731 1 6.5 1C4.1269 1 2.20312 2.92378 2.20312 5.29688C2.20312 7.13371 4.77744 10.3396 5.94091 11.6946C6.23815 12.0408 6.76185 12.0408 7.05909 11.6946Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/Location.84179cfcbb21ad16dcd4a9861a1fc8d3.svg";
export { ForwardRef as ReactComponent };